<template>
	<div style="width: 95%;margin: 0 auto;">
		<div style="width: 100%;height: 90px;">
			<div
				style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
				展会会议
			</div>

			<div @click="ctm('4')" :class="qbeada === true?'czxa':'zxcas'">
				会议发布
			</div>
			<div @click="ctm('5')" :class="qbeadas === true?'czxa':'zxcas'">
				展会发布
			</div>
			<!-- <div @click="ctm('6')"
				style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				申请
			</div> -->
			<div @click="ctm('7')" :class="qbeadass === true?'czxa':'zxcas'">
				我要发布
			</div>
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 420px;height: 30px;font-weight: 800;text-align: center;line-height: 30px;font-size: 18px;margin-left: 20px;">
				<el-radio-group v-model="cid" @change="gotosb()">
					<el-radio-button label="4">会议发布</el-radio-button>
					<el-radio-button label="5">展会发布</el-radio-button>
					<el-radio-button label="6">申请</el-radio-button>
					<el-radio-button label="7">我要发布</el-radio-button>
				</el-radio-group>
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="cid=='4'" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in zha">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}  <span style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao" style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link :to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'1'} }" tag="div"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="cid=='5'" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in zha">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}<span style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao" style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link :to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'2'} }" tag="div"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="cid=='6'" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in zha">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<!-- <div
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</div> -->
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="cid=='7'">
				<div style="width: 100%;">

					<div style="width: 100%;height: 50px;">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							选择项目:
						</div>
						<el-radio-group v-model="form.radio1" style="margin-top: 5px;">
							<el-radio-button label="4">会议发布</el-radio-button>
							<el-radio-button label="5">展会发布</el-radio-button>
						</el-radio-group>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1!='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							标题:
						</div>
						<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1!='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							图片:
						</div>
						<el-upload class="upload-demo" action="https://admin.shipoe360.com/api/picture/upload_pic"
							:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
							:on-success="handsuccess" multiple :limit="3" :on-exceed="handleExceed"
							:file-list="fileList">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>

					<div style="width: 100%;height: 50px;margin-top: 25px;" v-show="form.radio1!='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							内容:
						</div>
						<el-input v-model="form.jianjie" style="float: left;width: 70%;margin-top: 5px;"></el-input>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1=='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							网址:
						</div>
						<el-input v-model="form.wangzhiaa" style="float: left;width: 70%;margin-top: 5px;"></el-input>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1=='5'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							结束时间:
						</div>
						<el-date-picker style="margin-top: 5px;" v-model="form.value1" type="date" placeholder="选择日期">
						</el-date-picker>
					</div>

					<div style="width: 100%;height: 50px;">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							月份:
						</div>
						<el-select style="margin-top: 5px;" v-model="form.yuefen" placeholder="请选择月份"
							:popper-append-to-body="false" popper-class="select-popper">
							<el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item">
							</el-option>
						</el-select>
					</div>

					<div style="width: 100%;height: 550px;" v-show="form.radio1!='6'">
						<div style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;">
							简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
						</div>
						<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
							<vue-tinymce v-model="form.content" :setting="setting" />
						</div>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1=='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							姓名:
						</div>
						<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1=='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							展会名:
						</div>
						<el-input v-model="form.zhanhuiminga" style="float: left;width: 70%;margin-top: 5px;">
						</el-input>
					</div>

					<div style="width: 100%;height: 50px;" v-show="form.radio1=='6'">
						<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
							展号:
						</div>
						<el-input v-model="form.zhanhaoa" style="float: left;width: 70%;margin-top: 5px;"></el-input>
					</div>

					<div style="height: 50px;width: 200px;margin: 0 auto;">
						<el-button type="primary" @click="onSubmit">立即创建</el-button>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				fileList: [],
				cid: '4',
				form: {
					content: '',
					imageUrlpic: '', //图片文件
					radio1: '', //项目选择
					msg: '', //内容
					title: '', //标题,姓名
					wangzhiaa: '', //网址
					value1: '', //结束日期
					xingminga: '', //姓名
					shzt: '0', //审核状态
					jianjie: '', //简介
					yuefen: '', //月份
					zhanhuiminga: '', //展会名
					zhanhaoa: '', //展号啊
				},
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				zha: '',
				qbeada: false,
				qbeadas: false,
				qbeadass: false,
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				optionss: [{
					label: '1',
					value: '1'
				}, {
					label: '2',
					value: '2'
				}, {
					label: '3',
					value: '3'
				}, {
					label: '4',
					value: '4'
				}, {
					label: '5',
					value: '5'
				}, {
					label: '6',
					value: '6'
				}, {
					label: '7',
					value: '7'
				}, {
					label: '8',
					value: '8'
				}, {
					label: '9',
					value: '9'
				}, {
					label: '10',
					value: '10'
				}, {
					label: '11',
					value: '11'
				}, {
					label: '12',
					value: '12'
				}, ],
				xsa: false,
				qid: '',
			}
		},
		mounted() {
			this.gotosb()
		},
		methods: {
			ctm(val) {
				this.cid = val
				this.gotosb()
				if (val == '4') {
					this.qbeada = true
					this.qbeadas = false
					this.qbeadass = false
				} else if (val == '5') {
					this.qbeadas = true
					this.qbeada = false
					this.qbeadass = false
				} else if (val == '7'){
					this.qbeadas = false
					this.qbeada = false
					this.qbeadass = true
				}
			},
			handlePreview(file) {
				console.log(file);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccess(response, file, fileList) {
				this.form.imageUrlpic = response.data.path
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'meet',
					type: 'content',
					mid: this.cid,
					field_name: 'id',
					field_id: id,
					uid: loginInfo.id,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.gotosb()
				}
			},
			xiugaia(val) {
				console.log(val)
				var sb = true
				var sb2 = 'http://admin.shipoe360.com/public/'
				this.xsa = true
				this.cid = '7'
				this.form.radio1 = val.mid
				this.form.title = val.title
				this.form.imageUrlpic = val.picture
				this.form.status = val.status
				this.form.content = val.content
				this.form.yuefen = val.month
				this.form.jianjie = val.describ
				this.form.value1 = val.end_time
				this.qid = val.id
				this.form.zhanhaoa = val.zhanhao
				this.form.zhanhuiminga = val.zhan
				this.form.wangzhiaa = val.link
				
				if(this.form.imageUrlpic === 'http://admin.shipoe360.com/public/'){
					this.form.imageUrlpic = ''
					sb = true
				} else {
					this.form.imageUrlpic = this.form.imageUrlpic.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
					sb = false
				}
				console.log(this.form.imageUrlpic)
				if(sb){
					console.log('不用')
				} else {
					let fileArrs = [];
					let fileObjs = {};
					fileObjs.name = "图片";
					fileObjs.url = val.picture;
					fileArrs.push(fileObjs);
					this.fileList = fileArrs
				}
				
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)

				if (this.cid == '4') {
					let res = await http.get('api/picture/personl_page_hyhy', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.zha = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				} else {
					let res = await http.get('api/picture/personl_page_hyzh', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.zha = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				}

			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'meet',
					type: 'content',
					mid: this.cid,
					uid: loginInfo.id,
				})
				this.zha = res.data.data.list.data
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					let res = await http.post('api/Common/edit', {
						model: 'meet',
						type: 'content',
						mid: this.form.radio1, //模型id
						title: this.form.title, //标题
						picture: this.form.imageUrlpic, //图片
						id: this.qid,
						status: '0', //状态
						content: this.form.content, //内容
						describ: this.form.jianjie, //简介
						uid: loginInfo.id, //上传者信息
						end_time: this.form.value1, //结束日期
						zhanhao: this.form.zhanhaoa, //展号
						zhan: this.form.zhanhuiminga, //展会名
						link: this.form.wangzhiaa, //网址
						month: this.form.yuefen.value, //月份
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '发布成功',
							type: 'success'
						});
						this.gotosb()
						this.fileList = []
						this.form.content = ''
						this.form.imageUrlpic = ''
						this.form.radio1 = ''
						this.form.msg = ''
						this.form.title = ''
						this.form.wangzhiaa = ''
						this.form.value1 = ''
						this.form.xingminga = ''
						this.form.shzt = '0'
						this.form.jianjie = ''
						this.form.yuefen = ''
						this.form.zhanhuiminga = ''
						this.form.zhanhaoa = ''
					}
				} else if (this.xsa == false) {
					let res1 = await http.post('api/Common/add', {
						model: 'meet',
						type: 'content',
						mid: this.form.radio1, //模型id
						title: this.form.title, //标题
						picture: this.form.imageUrlpic, //图片
						status: '0', //状态
						content: this.form.content, //内容
						describ: this.form.jianjie, //简介
						month: this.form.yuefen.value, //月份
						uid: loginInfo.id, //上传者信息
						end_time: this.form.value1, //结束日期
						zhanhao: this.form.zhanhaoa, //展号
						zhan: this.form.zhanhuiminga, //展会名
						link: this.form.wangzhiaa //网址
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '发布成功',
							type: 'success'
						});
						this.gotosb()
						this.fileList = []
						this.form.content = ''
						this.form.imageUrlpic = ''
						this.form.radio1 = ''
						this.form.msg = ''
						this.form.title = ''
						this.form.wangzhiaa = ''
						this.form.value1 = ''
						this.form.xingminga = ''
						this.form.shzt = '0'
						this.form.jianjie = ''
						this.form.yuefen = ''
						this.form.zhanhuiminga = ''
						this.form.zhanhaoa = ''
					}
				}
			}
		}
	}
</script>

<style>
	.czxa {
		width: 200px;
		height: 30px;
		border: 1px solid #000;
		color: #FFF;
		text-align: center;
		line-height: 30px;
		margin-top: 10px;
		float: left;
		margin-left: 5px;
		background-color: rgba(255, 68, 0, 0.3);
	}

	.zxcas {
		width: 200px;
		height: 30px;
		border: 1px solid #000;
		text-align: center;
		line-height: 30px;
		margin-top: 10px;
		float: left;
		margin-left: 5px;
	}
</style>
